(function () {

  angular
    .module('meanApp')
    .directive('bgImage', bgImage);

  function bgImage () {
    return {
        link: function(scope, element, attr) {

            attr.$observe('bgImage', function() {           
              if (!attr.bgImage) {
                 // No attribute specified, so use default
                 element.css("background-image","url("+scope.defaultImage+")");
              } else {
                 var image = new Image();  
                 image.src = attr.bgImage;
                 image.onload = function() { 
                    //Image loaded- set the background image to it
                    if(attr.bgImage) {
                      element.css("background-image","url("+attr.bgImage+")");
                    }
                 };
                 image.onerror = function() {
                    //Image failed to load- use default
                    if(scope.defaultImage) {
                       element.css("background-image","url("+scope.defaultImage+")");
                    }
                 };
             }
         });
      }
    };
  }

})();